/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export default class LimitedAction
{
    private _action: Function;

    private _current: number = 0;
    private _limit: number;

    constructor(action: Function, limit: number = 1)
    {
        this._action = action;
        this._limit = limit > 0 ? limit : 1;
    }

    public Execute(): void
    {
        if (this._current < this._limit)
        {
            this._current++;
            return;
        }
        this._action();
        this._current = 0;
    }
}
